module.exports = __webpack_public_path__ + "static/media/ashokLeyland.a95170fe.svg";